import clsx from 'clsx';
import type { ChangeEventHandler } from 'react';

type Props = {
  label: string;
  name: string;
  value: string;
  defaultChecked?: boolean;
  className?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

export const RadioButton = ({ label, name, value, defaultChecked, className, onChange }: Props) => (
  <label className={clsx('flex items-center justify-between', className)}>
    <span>{label}</span>
    <div className="w-6 h-6 rounded-full border border-cta flex-shrink-0 flex items-center justify-center ml-2">
      <input
        type="radio"
        name={name}
        value={value}
        className="hidden peer"
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      <div className="w-4 h-4 rounded-full bg-cta hidden peer-checked:block" />
    </div>
  </label>
);
